import {toggleProgressBarDisplayingAction, toggleSaveReminderDisplayingAction} from '@Components/loading-toast';
import {
  eventProgressHandler,
  hideLoading,
  showLoading,
  updateLoadingProgress,
  updateLoadingText,
  isLoaderActiveForKey,
  smoothEstimateLoadingProgress,
} from '@Libraries/loading-toast-library';

window.PMW.mergePMW(window.PMW, {
  /**
   * Shows the loading toast
   * @param {string} key
   * @param {Object} [opts]
   */
  showLoading: (key: string, opts = {}) => {
    showLoading(key, opts);
  },

  toggleSaveReminderDisplaying: (val: boolean) => {
    window.PMW.redux.store.dispatch(toggleSaveReminderDisplayingAction(val));
  },

  /**
   * Update whether the progress bar is displaying or not
   * @param {boolean} val
   */
  toggleProgressBarDisplaying: (val: boolean) => {
    window.PMW.redux.store.dispatch(toggleProgressBarDisplayingAction(val));
  },

  /**
   * Hides the loading toast for the key
   * @param {string} key
   */
  hideLoading: (key: string) => {
    hideLoading(key);
  },

  /**
   * Progress handler for a progress bar. Goes up to 90%, leaving 10% for server side processing
   * @param {string} loadingKey
   * @param {object} e EventData
   */
  eventProgressHandler: (loadingKey: string, e: any) => {
    eventProgressHandler(loadingKey, e);
  },
  /**
   * Update the loading progress
   * @param {string} key
   * @param {number} progress
   */
  updateLoadingProgress: (key: string, progress: any) => {
    updateLoadingProgress(key, progress);
  },
  /**
   * @param {string} key
   * @param {number} durationMs
   * @param {number} steps
   */
  smoothEstimateLoadingProgress: (key: string, durationMs: number, steps: number) => {
    smoothEstimateLoadingProgress(key, durationMs, steps);
  },

  /**
   * Update the loading text
   * @param {string} key
   * @param {string} text
   */
  updateLoadingText: (key: string, text: string) => {
    updateLoadingText(key, text);
  },

  /**
   * Given a key, this function returns if that loader is active
   * @param {string} key
   * @returns {boolean}
   */
  isLoaderActiveForKey: (key: string) => {
    return isLoaderActiveForKey(key);
  },
});
